import { Badge } from "reactstrap";
import { dateTime } from "../../utils/date.utils";
import { locationNeedDateInput } from "../../utils/stockList.utils";

export default function StockListLocation({ location, date }) {
  const isSold = location === "Sold" || location === "Not Showing";
  return isSold ? (
    <Badge color="danger">{location}</Badge>
  ) : (
    <div>
      <div>{location}</div>
      {locationNeedDateInput.includes(location) && <div>{dateTime(date, "d MMM yyyy")}</div>}
    </div>
  );
}
